import React from 'react';
import PropTypes from 'prop-types';

export const ServerSideDefaultComponent = ({
  Component,
  topItemId,
  hydrationId,
  ...componentProps
}) => {
  const content = <Component {...componentProps} topItemId={topItemId} />;

  return (
    <div style={{ display: 'contents' }} id={hydrationId}>
      {content}
    </div>
  );
};

ServerSideDefaultComponent.displayName = 'ServerSideDefault';

export const createServerSideDefault = (component) => {
  const ServerSideDefault = (props) =>
    ServerSideDefaultComponent({ ...props, Component: component });

  ServerSideDefault.rootDisplayName = ServerSideDefaultComponent.displayName;

  ServerSideDefault.displayName = component.displayName;
  ServerSideDefault.app = component.app;

  return ServerSideDefault;
};

ServerSideDefaultComponent.propTypes = {
  Component: PropTypes.func.isRequired,
  topItemId: PropTypes.string.isRequired,
  hydrationId: PropTypes.string.isRequired,
};